import { defineStore } from "pinia";

export const useDeviceStore = defineStore("device", {
  state: () => {
    return {
      isShowingKeyboard: false,
      applicationIsActive: true,
    };
  },
  getters: {},
  actions: {
    setKeyboardSatus(isShowing: boolean) {
      this.isShowingKeyboard = isShowing;
    },
    updateApplicationActiveStatus(isActive: boolean) {
      this.applicationIsActive = isActive;
    },
  },
});
